const initialState = {
  categories: {
    error: null,
    datos: [],
    loading: false,
    status: null,
    selected: {
      categoryId:null,
      categoryName: ""
    }
  },
  tags: {
    loading: false,
    error: null,
    status: null,
    datos: [],
    newDataToSave:false
  },
  tagsChanges: {
    datos: [],
    loading: false,
    error: null,
    status: null,
    tagsNotSaved: []
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/account_tag/initialState.js